import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indianFormat',
    standalone: false
})
export class IndianFormatPipe implements PipeTransform {
    transform(value: string | number): string {
        let numericValue: number;

        // Convert string to number if value is a string
        if (typeof value === 'string') {
            numericValue = +value;
        } else {
            numericValue = value;
        }

        // Check if numericValue is a valid, finite number
        if (typeof numericValue === 'number' && !Number.isNaN(numericValue) && isFinite(numericValue)) {
            // Extract decimal part
            const decimalPart = numericValue - Math.floor(numericValue);

            // Round off based on decimal part
            const roundedValue = decimalPart > 0.5 ? Math.ceil(numericValue) : Math.floor(numericValue);

            return roundedValue.toLocaleString('en-IN');
        } else if (typeof numericValue === 'number' && !Number.isNaN(numericValue) && !isFinite(numericValue)) {
            // Explicitly handle Infinity and -Infinity
            return '0';
        } else if (value) {
            // Handle non-numeric string inputs
            return value.toString();
        }

        return ''; // Return empty string for null or undefined values
    }
}
